export default {"src":"/_next/static/media/spark.9e43c7eb.svg","height":1046,"width":1046,"blurWidth":0,"blurHeight":0};